import type { AppConfig, AuthConfig } from '@scansource-brazil/zeus-core-ui/types';

/**
 * Fetches config.json, then run callback.
 * @param callback
 */
async function preMount(callback: (args: any) => any) {
  try {
    const config = await fetchConfig();
    if (!config) return;
    return callback(prepareConfig(config));
  } catch (error) {
    console.error('something wrong pre mounting:', error);
  }
}

async function fetchConfig() {
  try {
    return await fetch('/config.json').then((res) => res.json());
  } catch (error) {
    console.error('something wrong fetching config', error);
    return null;
  }
}

function prepareConfig(config: any): Record<string, any> {
  return {
    kcConfig: {
      url: config.AUTH_URL,
      realm: config.REALM,
      clientId: config.CLIENT_ID,
    },
    appConfig: {
      baseURL: config.BASE_URL,
      accountsURL: config.ACCOUNTS_URL,
      clientId: config.CLIENT_ID,
    },
    featConfig: {
      url: config.FEATURE_FLAG_URL,
    },
  };
}

export default preMount;
